import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable import/no-cycle */
import { memo } from "react";
import star from "Images/checkout/starGrey.svg";
import { CustomCarousel } from "Root/checkout/components";
import styles from "./styles.module.css";
const ReviewsBlock = ({ reviews }) => (_jsx("div", { className: styles.wrapper, children: _jsxs("div", { className: styles.container, children: [_jsx("div", { className: styles.title, children: "Reviews from other people like you." }), _jsx(CustomCarousel, { extraSettings: {
                    slidesToShow: 4,
                    arrows: false,
                    infinite: false,
                    centerMode: false,
                    centerPadding: "10px",
                    initialSlide: 0,
                    responsive: [
                        {
                            breakpoint: 1201,
                            settings: {
                                slidesToShow: 3.1,
                                initialSlide: 0,
                                centerMode: false,
                            },
                        },
                        {
                            breakpoint: 999,
                            settings: {
                                slidesToShow: 2.1,
                                initialSlide: 0,
                                centerMode: false,
                            },
                        },
                        {
                            breakpoint: 601,
                            settings: {
                                slidesToShow: 1.05,
                                initialSlide: 0,
                                centerMode: true,
                                centerPadding: "10px",
                            },
                        },
                    ],
                }, className: styles.carousel, children: reviews.map((review) => (_jsxs("div", { className: styles.review, children: [_jsx("div", { className: styles.name, children: review.review_name }), _jsxs("div", { className: styles.rating, children: [_jsx("img", { src: star, alt: "", width: 17, height: 15 }), _jsx("img", { src: star, alt: "", width: 17, height: 15 }), _jsx("img", { src: star, alt: "", width: 17, height: 15 }), _jsx("img", { src: star, alt: "", width: 17, height: 15 }), _jsx("img", { src: star, alt: "", width: 17, height: 15 })] }), _jsx("hr", {}), _jsx("div", { className: styles.heading, children: review.heading }), _jsx("p", { className: styles.body, children: review.body })] }, review.heading))) })] }) }));
export default memo(ReviewsBlock);
